const initialState = {
  fetching: false,
  fetched: false,
  items: [],
  nbResult: 0,
  organizationId: 0,
  error: null,
};

export const participantOrganizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'INITIALIZED_PARTICIPANT_ORGANIZATION': {
      return initialState;
    }
    case 'FETCH_PARTICIPANT_ORGANIZATION_PENDING': {
      return { ...state, fetching: true };
    }
    case 'FETCH_PARTICIPANT_ORGANIZATION_FULFILLED': {
      const { data, nbResult } = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data,
        nbResult,
      };
    }
    case 'FETCH_PARTICIPANT_ORGANIZATION_REJECTED': {
      let error = action.payload;
      switch (error.response?.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404,
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error,
      };
    }
    default:
      return state;
  }
};

const initialStateForRankingClientsSort = {
  sortConfig: {
    columnKey: 'score',
    sortDirection: 'desc',
  },
};

export const participantOrganizationSortReducer = (state = initialStateForRankingClientsSort, action) => {
  switch (action.type) {
    case 'INITIALIZED_PARTICIPANT_ORGANIZATION': {
      return initialStateForRankingClientsSort;
    }
    case 'SET_PARTICIPANT_ORGANIZATION_LIST_SORT_CONFIG': {
      return { ...state, sortConfig: action.config };
    }
    default:
      return state;
  }
};
